import api from '../api'
import { loadEntity } from 'lib/actionHelpers'

const getEntityKey = organizationApikey =>
  `hierarchicalNetworkMembers:${organizationApikey}`

export function load(organizationApikey){
  if (!organizationApikey) throw new Error(`organizationApikey undefined`)
  return loadEntity.call(this, {
    reload: true,
    entityKey: getEntityKey(organizationApikey),
    request: () =>
      api.getHierarchicalNetworkMembers(organizationApikey)
  })
}
